import React from 'react';

import { Button } from '@mui/material';
import InAppSpy from 'inapp-spy';

import type { ButtonProps } from '@mui/material';

export type OpenBrowserButtonProps = Omit<ButtonProps, 'onClick'>;

const OpenBrowserButton = (props: OpenBrowserButtonProps) => {
  const [{ isInApp }] = React.useState(() => InAppSpy());

  const openAndroidBrowser = () => {
    const uri = `intent://${window.location.host}${window.location.pathname}#Intent;scheme=${window.location.protocol};end`;
    window.location.href = uri;
  };

  const openIOSBrowser = () => {
    const chromeUri = `googlechromes://${window.location.host}${window.location.pathname}`;
    window.location.href = chromeUri;

    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        const safariUri = `x-safari-https://${window.location.host}${window.location.pathname}`;
        window.location.href = safariUri;
      }
    }, 500);
  };

  const openBrowser = () => {
    window.open(window.location.href, '_blank');
  };

  const openBrowserHandler = () => {
    const { userAgent } = window.navigator;
    if (isInApp) {
      if (/Android/.test(userAgent)) {
        openAndroidBrowser();
        return;
      }
      if (/iPhone|iPad|iPod/.test(userAgent)) {
        openIOSBrowser();
        return;
      }
    }
    openBrowser();
  };

  return (
    <Button {...props} onClick={openBrowserHandler}>
      {props.children ?? 'Open Browser'}
    </Button>
  );
};

export default OpenBrowserButton;
